module.exports = __webpack_public_path__ + "static/media/intro-screen.8a0127ef.svg";